import React from 'react';
import { Steps, Button, Radio, Form, Modal } from '@roo/roo';
import { Col, Row } from '@roo/roo/Grid';
import QRCode from 'qrcode';
import { getEnv } from '@/utils';
import urlUtil from '@/utils/url';
import request from '@/utils/request';
import report from '@/utils/report';
import './faceRecognition.scss';

const { useState, useEffect } = React;

const { Field } = Form;

interface Iprops {
    // closeOpenLivePage: () => void;
    hasAuthenticated: boolean;
    history: any;
}

const Index = (props: Iprops) => {
    const { history } = props;
    const [activeStep, setActiveStep] = useState(0);
    const [success, setSuccess] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [imgUrl, setImgUrl] = useState('');
    const [uuid, setUuid] = useState('');
    const formRef = React.useRef<Form>(null);

    useEffect(() => {
        report.lxGet('uuid').then((res: string) => {
            console.log(res);
            setUuid(res);
        });
    }, []);

    /** 轮询请求结果，每隔2s，成功后轮询停止 */
    const queryResult = () => {
        request
            .get('/api/liveRoom/authentication/result', {
                busId: urlUtil.commonParams.providerId,
                busLine: 1,
            })
            .then(res => {
                const { authenticationResult } = res.data;
                /**
                 * authenticationResult 0-未认证，1-认证中，2-认证成功，3-认证失败
                 */
                if (authenticationResult === 2 || authenticationResult === 3) {
                    // 得到结果了
                    setSuccess(authenticationResult === 2);
                    setActiveStep(3);
                } else {
                    // 没得到结果，还在认证中或未认证，重新请求
                    setTimeout(() => {
                        queryResult();
                    }, 2000);
                }
            })
            .catch(() => {
                // 失败了重新请求
                setTimeout(() => {
                    queryResult();
                }, 2000);
            });
    };

    /**
     * 生成认证URL
     * @param requestCode 认证code
     */
    const getAuthenticationUrl = (requestCode: string) => {
        // url中的env变量和现有的不一致，需要再转换一下
        const envMap = {
            stage: 'staging',
            test: 'test',
            prod: 'pro',
        };
        const env = envMap[getEnv()];
        const yodaDomainMap = {
            pro: 'https://verify.meituan.com',
            staging: 'https://verify.inf.st.meituan.com',
            test: 'https://verify.inf.test.meituan.com',
        };
        const marketDomainMap = {
            test: 'http://waimai-eci-231201-164501-227-sl-e.platform.proxy.b.waimai.test.sankuai.com',
            staging: 'https://proxy.waimai.st.sankuai.com',
            pro: 'https://waimaieapp.meituan.com',
        };
        const callbackUrl = (f: 0 | 1) =>
            `${marketDomainMap[env]}/wmeactivity/marketFaceRecognitionResult?success=${f}`;
        const params = {
            requestCode,
            env,
            webviewNav: false,
            succCallbackUrl: encodeURIComponent(callbackUrl(1)),
            failCallbackUrl: encodeURIComponent(`${callbackUrl(0)}&request_code=${requestCode}`), // 失败的场景手动拼上requestCode
        };
        const paramsStr = Object.keys(params)
            .map(k => `${k}=${params[k]}`)
            .join('&');
        const url = `${yodaDomainMap[env]}/v2/app/general_page?${paramsStr}`;
        return url;
    };

    const formSubmit = (values, err) => {
        if (err) return;
        setBtnDisabled(true);
        console.log(values);
        const params = {
            ...values,
            busId: urlUtil.commonParams.providerId,
            busLine: 1,
            uuid,
        };
        request
            .get('/api/liveRoom/authentication/info', params)
            .then(res => {
                const { requestCode } = res.data;
                /** 进入人脸验证 */
                setActiveStep(2);
                const authenticationUrl = getAuthenticationUrl(requestCode);
                console.log('authenticationUrl', authenticationUrl);
                /** 生成二维码URL */
                QRCode.toDataURL(authenticationUrl, (err, url) => {
                    if (err) throw err;
                    setImgUrl(url);
                });
                /** 开启轮询查接口 */
                queryResult();
            })
            .finally(() => {
                setBtnDisabled(false);
            });
    };

    const renderStepContent = () => {
        if (activeStep === 0) {
            // 引导页面
            return (
                <div>
                    <Row>
                        <Col span={5}>
                            <ul>
                                <li>•&nbsp;确保是本人出镜直播</li>
                                <li>•&nbsp;未满十八周岁不允许开播</li>
                                <div style={{ marginTop: '20px' }}>
                                    <li>
                                        <Radio disabled>输入姓名</Radio>
                                    </li>
                                    <li>
                                        <Radio disabled>输入身份证号</Radio>
                                    </li>
                                </div>
                            </ul>
                        </Col>
                        <Col span={4}>
                            <ul>
                                <li>•&nbsp;确保脸部清晰完整，光线充足</li>
                                <div style={{ marginTop: '20px' }}>
                                    <li>
                                        <Radio disabled>人脸识别</Radio>
                                    </li>
                                </div>
                            </ul>
                        </Col>
                    </Row>
                </div>
            );
        }
        if (activeStep === 1) {
            return (
                <>
                    <ul>
                        <li>•&nbsp;确保是本人出镜直播</li>
                        <li>•&nbsp;未满十八周岁不允许开播</li>
                    </ul>
                    <div style={{ marginTop: '20px' }}>
                        <Form ref={formRef} onSubmit={formSubmit} value={{}}>
                            <Field
                                required
                                label="姓名"
                                name="name"
                                rule={[{ required: true, message: '请输入姓名' }]}
                            />
                            <Field
                                required
                                label="身份证号"
                                name="idCard"
                                rule={[{ required: true, message: '请输入身份证号' }]}
                            />
                        </Form>
                    </div>
                </>
            );
        }
        if (activeStep === 2) {
            // 人脸认证页
            return (
                <div style={{ width: '60%', margin: '0 auto' }}>
                    <ul>
                        <li>•&nbsp;确保脸部清晰完整，光线充足</li>
                        <li>•&nbsp;请使用美团 App 扫描下方二维码进行人脸识别</li>
                    </ul>
                    {imgUrl !== '' && <img src={imgUrl} alt="" />}
                </div>
            );
        }
        if (activeStep === 3) {
            // 认证结果页
            const text = success ? '恭喜！已完成认证' : '抱歉！验证失败';
            const imgSrc = success
                ? 'https://s3plus.meituan.net/v1/mss_0e4451a82e1d428f9fc3b99c0b3ebf15/pic-manager/5e5d3cceea8ff380/Success-icon.png'
                : 'https://s3plus.meituan.net/v1/mss_0e4451a82e1d428f9fc3b99c0b3ebf15/pic-manager/214386e19e57de28/Error-icon.png';
            return (
                <div style={{ width: '40%', margin: '0 auto' }}>
                    <p style={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={imgSrc} width={20} alt="icon" />
                        {text}
                    </p>
                </div>
            );
        }
        return null;
    };

    const handleClickBtn = () => {
        if (activeStep === 0) {
            // 引导页
            const { hasAuthenticated } = props;
            if (hasAuthenticated) {
                Modal.confirm({
                    title: '注意',
                    children:
                        '当前账号直播间主播二要素认证中，请耐心等待。再次认证将会覆盖认证结果',
                    status: 'info',
                    onConfirm: () => {
                        setActiveStep(1);
                    },
                    onCancel: () => {},
                    showCancelButton: true,
                });
            } else {
                // 正常进入下一步
                setActiveStep(1);
            }
        } else if (activeStep === 1) {
            // 身份认证页
            formRef.current?.handleSubmit();
        } else if (activeStep === 3) {
            // 最后一步操作
            if (success) {
                // 成功的话点击创建直播间
                history.push('/live/edit');
            } else {
                // 不成功重新认证，刷新页面
                window.location.reload();
            }
        }
    };

    const renderFooter = () => {
        const ReadText = () => (
            <p>
                开播前建议仔细阅读：
                <a
                    href="https://collegewm.meituan.com/?r=1#/college/detail?id=2578&contentType=1&utm_content_source=FWSHT"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    外卖商家端直播操作手册
                </a>
            </p>
        );
        const btnTextArr = ['开始实名认证', '下一步', '', success ? '创建直播间' : '重新认证'];
        if (activeStep === 2) {
            return null;
        }
        return (
            <>
                {(activeStep === 0 || activeStep === 3) && <ReadText />}
                <Button onClick={handleClickBtn} disabled={btnDisabled}>
                    {btnTextArr[activeStep]}
                </Button>
            </>
        );
    };

    return (
        <div style={{ margin: '0 auto', width: '70%', color: 'black' }}>
            <div style={{ textAlign: 'center' }}>
                <h2>直播开播认证</h2>
                <p>
                    根据《网络直播营销管理方法（试行）》相关法规要求，直播开播前需完成“主播”实名认证后才能发起直播。相关流程如下：
                </p>
            </div>
            <Steps
                active={activeStep}
                textPosition="right"
                steps={['主播身份认证', '主播人脸认证', '认证完毕']}
                className="face-steps"
            />
            <div style={{ height: '40%', padding: '50px 0' }}>{renderStepContent()}</div>
            <div style={{ textAlign: 'center' }}>{renderFooter()}</div>
        </div>
    );
};

export default Index;
